import { useMediaQuery } from './useMediaQuery';

const MOBILE_MAX_WIDTH = 639;

export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
}
